const tipoSituacaoDoencaList = [
    {
        id: 'C',
        descricao: 'Curado',
        ordem: 10,
    },
    {
        id: 'T',
        descricao: 'Em tratamento',
        ordem: 20,
    },
    {
        id: 'A',
        descricao: 'Acompanhamento Padrão Assintomático',
        ordem: 30,
    },
]

export default tipoSituacaoDoencaList
